export const DEFAULT_ACTION = "app/OpenCasesDetailsPage/DEFAULT_ACTION";
export const CLAIMNUMBERUPDATE = "app/OpenCasesDetailsPage/CLAIMNUMBERUPDATE";